import React, { useState } from 'react';
import { Modal, Button, Alert, Spinner, Form } from 'react-bootstrap';
//API 
import { OrdersFetchAPI } from '../../../api/Orders';
import { ClientsFetchAPI } from '../../../api/Clients';
import ErrorAlert from '../../Alerts/ErrorAlert';
//Modules 
import QrScanner from '../../../utils/QrScanner'; // Asegúrate de que la ruta sea correcta
import { useTranslation } from 'react-i18next';

// Component
const ModalAddPoints = ({ frecuentShopperConfig, show, handleClose, business_code, branchoffice, token, clientInfo, setClientInfo }) => {
  const { t } = useTranslation();
  const [orderCode, setOrderCode] = useState('');
  const [processing, setProcessing] = useState(false);
  const [order, setOrder] = useState(null);
  const [qrData, setQrData] = useState('');
  const [modalByCode, setModalByCode] = useState(false);
  const [showModalScanner, setShowModalScanner] = useState(false);
  // Function to handle the submission of the order
  const handleSubmit = async (order) => {
    let points = order.total;
    // Check if the frecuent shopper config is enabled
    if (!frecuentShopperConfig != null) {
      points = frecuentShopperConfig.point_value * order.total;
    }
    //We verify that the points are a decimal number
    if (points % 1 !== 0) {
      // If points are not an integer, we just asing the integer part
      points = Math.floor(points);
    }

    setProcessing(true);
    try {
      // We add the points to the client
      await ClientsFetchAPI.manageFrequentShopperPoints(clientInfo.id, {
        description: "Obtencion de puntos por orden #" + orderCode.trim(),
        action: "add",
        points: order.total,
        order_id: order.order_id,
      }, token);
      // We update the client info with the new points
      setClientInfo((prev) => ({
        ...prev,
        points: prev.points + points,
      }));
      //We update the client points on the local storage 
      localStorage.setItem('client', JSON.stringify({
        ...clientInfo,
        points: clientInfo.points + points,
      }));
      //We close the all modals
      setModalByCode(false);
      setShowModalScanner(false);
      handleClose();

      ErrorAlert("", t('profile.modals.addPoints.pointsAssignedSuccess'), "success");
      // We reset the  code
      setOrderCode('');
    } catch (err) {
      console.error(err);
      ErrorAlert(err.response.data.error, t('profile.shared.warningTitle'), "warning");
    } finally {
      setProcessing(false);
    }
  };

  // Function to get the order by transaction code
  const getOrderByCode = async () => {
    ErrorAlert("", t('profile.modals.addPoints.assigningPoints'), "info");
    // Validar que el código de la orden no esté vacío
    if (!orderCode.trim()) {
      ErrorAlert(t('profile.shared.errorTitle'), t('profile.modals.addPoints.orderCodeRequired'), "warning");
      return;
    } else {
      try {
        const response = await OrdersFetchAPI.getOrderByCode(orderCode.trim(), false, branchoffice.id, token);
        setOrder(response.data.order);
        handleSubmit(response.data.order);
      } catch (err) {
        //console.log(err);
        ErrorAlert(t('profile.modals.addPoints.orderSearchError'), t('profile.modals.addPoints.orderSearchErrorRetry'), "warning");
      }
    }
  }
  // Function to handle the QR scan
  const handleScan = (data) => {
    //console.log("Escaneando QR:", data);
    setQrData(data);
    let orderCode = data.split("/order/")[1]?.split("/")[0];
    if (!orderCode) {
      ErrorAlert(t('profile.shared.errorTitle'), t('profile.modals.addPoints.qrInvalidOrder'), "warning");
    } else {
      setOrderCode(orderCode);
      setShowModalScanner(false);
      getOrderByCode();
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('profile.modals.addPoints.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Button for modal by code */}
          <div className="modal-cupon-btn-section">
            <button
              className="modal-cupon-btn m-1"
              onClick={() => setModalByCode(true)}
            >
              {t('profile.modals.addPoints.byCode')}
            </button>

            <button
              className="modal-cupon-btn m-1"
              onClick={() => setShowModalScanner(true)}
            >
              {t('profile.modals.addPoints.scanQr')}
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={processing}>
            {t('common.cancel')}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Button to open the modal to assign order by code */}
      <Modal show={modalByCode} onHide={() => setModalByCode(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('profile.modals.addPoints.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="orderCode">
            <Form.Label>{t('profile.modals.addPoints.orderCodeLabel')}</Form.Label>
            <Form.Control
              type="text"
              placeholder={t('profile.modals.addPoints.orderCodePlaceholder')}
              value={orderCode}
              onChange={(e) => setOrderCode(e.target.value)}
              disabled={processing}
            />
          </Form.Group>

          {processing && (
            <div className="text-center mt-3">
              <Spinner animation="border" />
              <p>{t('profile.modals.addPoints.assigningOrder')}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalByCode(false)} disabled={processing}>
            {t('common.cancel')}
          </Button>
          <Button variant="primary" onClick={getOrderByCode} disabled={processing}>
            {t('profile.modals.addPoints.assignOrder')}
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal
        show={showModalScanner}
        onHide={() => setShowModalScanner(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('profile.modals.addPoints.scanClientQrTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{t('profile.modals.addPoints.aimCamera')}</p>
          <div className='m-3'>
            <QrScanner
              size={500}
              onScan={handleScan}
            />
          </div>
          {/* Código de cupón */}
          {processing && (
            <div className="text-center mt-3">
              <Spinner animation="border" />
              <p>{t('profile.modals.addPoints.assigningOrder')}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalScanner(false)} disabled={processing}>
            {t('common.cancel')}
          </Button>
        </Modal.Footer>

      </Modal>
    </>
  );
};

export default ModalAddPoints;

/* 
import React, { useState } from 'react';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';
import { QrReader } from 'react-qr-reader';

const ModalAddPoints = ({ show, handleClose, asignarOrden }) => {
  const [scanned, setScanned] = useState(false);
  const [error, setError] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [environment, setEnvironment] = useState('environment');

  const handleScan = async (data) => {
    if (data?.text && !scanned && !processing) {
      setScanned(true);
      setProcessing(true);
      try {
        await asignarOrden(data.text);
        handleClose();
      } catch (err) {
        console.error('Error asignando orden:', err);
        setError('Error al asignar la orden.');
        setProcessing(false);
        setScanned(false);
      }
    }
  };

  const handleError = (err) => {
    console.error('Error cámara:', err);
    setError('No se pudo acceder a la cámara. Verifica los permisos del navegador.');
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Escanear QR del Cliente</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Apunta la cámara al código QR. Se detectará automáticamente.</p>

        <div className="mb-3">
          <select
            className="form-select"
            value={environment}
            onChange={(e) => setEnvironment(e.target.value)}
          >
            <option value="environment">Cámara trasera</option>
            <option value="user">Cámara delantera</option>
          </select>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        {!processing ? (
          <QrReader
            key={environment}
            constraints={{ facingMode: environment }}
            onResult={(result, error) => {
              if (!!result) handleScan(result);
              if (!!error) handleError(error);
            }}
            style={{ width: '100%' }}
          />
        ) : (
          <div className="text-center">
            <Spinner animation="border" />
            <p>Asignando orden al cliente...</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={processing}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
 
export default ModalAddPoints;
*/